import { PropsWithChildren, ReactNode } from 'react';
import s from './IntroModalContent.module.scss';
import { Typography } from 'components';
import Point from './Point';
import { useTranslation } from 'react-i18next';

type Props = {
  heading: string;
  iconComponent: ReactNode;
  points: string[];
};

function IntroModalContent({
  children,
  iconComponent,
  heading,
  points,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation();
  return (
    <>
      <header>
        <div className={s.icon}>{iconComponent}</div>
        <Typography
          kind="h2"
          fontWeight={700}
          className={s.heading}
          dataTest="introModalContent-heading"
        >
          {heading}
        </Typography>
      </header>

      <section>
        <Typography
          kind="h3"
          size="m"
          fontWeight={700}
          className={s['section-heading']}
          dataTest="introModalContent-heading-intro"
        >
          {t('intro:how_it_works')}
        </Typography>

        <div className={s.box}>
          {points.map((point, index) => (
            <Point
              key={point}
              number={index + 1}
              description={point}
              dataTest={`introModalContent-point-${index}`}
            />
          ))}
        </div>
      </section>

      {children !== undefined && (
        <section data-test="introModalContent-children">{children}</section>
      )}
    </>
  );
}

export default IntroModalContent;
